import { CirclePicker, ChromePicker } from 'react-color';
import '../../../../styles/integrations.scss';
import { useCallback, useState } from 'react';
import { ReactComponent as DotsIcon } from '../../../../icons/icon-dots.svg';
import Label from './Label';

const popover = {
  position: 'absolute',
  zIndex: '999999',
};
const cover = {
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
};

const ColorPicker = ({ color, setColor, label }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const handleMoreColorsPickerVisibility = useCallback(() => {
    setDisplayColorPicker((prev) => !prev);
  }, [displayColorPicker]);

  const handleColorFromPopover = useCallback(
    (color) => {
      setColor(color.hex);

      console.log('color', color.hex);
    },
    [setColor]
  );

  return (
    <>
      <div className='integration__color-picker'>
        {label && <Label message={label} />}

        <div className='integration__color-picker--wrapper'>
          <CirclePicker
            width='245px'
            circleSize={20}
            circleSpacing={10}
            colors={['#DA0041', '#F24726', '#FAC710', '#8FD14F', '#0CA789', '#2D9BF0', '#3E4CB4', '#1A1A1A']}
            color={color}
            onChange={(color) => {
              setColor(color.hex);
            }}
          />

          <DotsIcon />

          <div className='integration__color-picker__dot' onClick={handleMoreColorsPickerVisibility}>
            +
          </div>
        </div>
      </div>
      {displayColorPicker ? (
        <div style={popover}>
          <div style={cover} onClick={handleMoreColorsPickerVisibility} />
          <ChromePicker color={color} onChangeComplete={handleColorFromPopover} disableAlpha={true} />
        </div>
      ) : null}
    </>
  );
};

export default ColorPicker;
